import React , {Component} from 'react'
import {   Col , Row , Icon } from 'antd';
import Tilt from 'react-tilt'
import Map from 'pigeon-maps'
import Marker from 'pigeon-marker'
import Overlay from 'pigeon-overlay'
import MainLayout from "../../components/layouts/mainLayout";
import Info from '../../components/common/info';

function seprator1() {
    return {
__html:'<svg preserveAspectRatio="xMidYMax meet" class="svg-separator sep4"\n'
      +
'viewBox="0 0 1600 200" style="display: block;" data-height="200">\n'
      +
        '<polygon className="" style="fill: rgb(27, 188, 155);"\n'
      +
        'points="886,86 800,172 714,86 -4,86 -4,204 1604,204 1604,86 "></polygon>\n'
      +
        '<polygon className="" style="opacity: 1;fill: #0e9382;"\n'
      +
        'points="800,172 886,86 900,86 800,186 700,86 714,86 "></polygon>\n'
      +
        '<polygon className="" style="opacity: 1;fill: #14a084;"\n'
      +
        'points="800,162 876,86 888,86 800,174 712,86 724,86 "></polygon>\n'
      +
        '</svg>'
    }
  }



function seprator2() {
   return {
      __html: ''
       +
        ' <svg id="" preserveAspectRatio="xMidYMax meet" class="sep2" viewBox="0 0 1600 200" style="display: block;" data-height="200">\n'
       +
        '<polygon class="" style="fill: #ecf0f1 ;" points="-4,0 1604,198 1604,204 -4,204 \t"></polygon>\n'
       +
        '<polygon class="" style="opacity: 1;fill: rgb(191,177,85);" points="1604,198 1604,186 -4,0 -4,0 \t"></polygon>\n'
       +
        '<polygon class="" style="opacity: 1;fill: rgb(150, 136, 70);" points="1604,186 1604,174 -4,0 -4,0 \t"></polygon>'
       +
        '</svg>'
     }
   }



export default class ContactUs extends Component{
      constructor(props){
          super(props);
              this.state = {
                viewport: {
                width: 400,
                height: 400,
                latitude: 37.7577,
                longitude: -122.4376,
                zoom: 12
                }
              }
            }
  render(){
    return(
        <MainLayout>
      <div className={"contactUsPageWrapper"}>
          <div className="contactUsSec1Row">
              <div className="container">
                  <div className="contactUs">
                      <div className="contactUsPhonesCard">
                          <Row className={"maincontactUsSec1Row"}>
                              <Col xs={22} sm={20} md={10} lg={10} xl={10}>
                                  <div className="contactUsPhones">
                                      <div className="contactUsPhone">
                                          <div className="contactUsPhoneIcon">
                                              <Icon type="phone"/>
                                          </div>
                                          <div className="contactUsPhoneTitle">
                                                    شماره تلفن ۱
                                          </div>
                                          <div className="contactUsPhonetext">
                                              {Info.PHONE}
                                          </div>
                                      </div>
                                        <div className="contactUsPhone">
                                            <div className="contactUsPhoneIcon">
                                                <Icon type="phone"/>
                                            </div>
                                            <div className="contactUsPhoneTitle">
                                                شماره تلفن ۲
                                            </div>
                                            <div className="contactUsPhonetext">{Info.PHONE}</div>
                                        </div>

                                        <div className="contactUsPhone">
                                            <div className="contactUsPhoneIcon">
                                                <Icon type="mobile"/>
                                            </div>
                                            <div className="contactUsPhoneTitle">
                                                شماره تلفن همراه
                                            </div>
                                            <div className="contactUsPhonetext">{Info.MOBILE}</div>
                                        </div>

                                        <div className="contactUsPhone">
                                            <div className="contactUsPhoneIcon">
                                                <Icon type="mail"/>
                                            </div>
                                            <div className="contactUsPhoneTitle">
                                                پست الکترونیکی
                                            </div>
                                            <div className="contactUsPhonetext">{Info.EMAIL}</div>
                                        </div>

                                        <div className="contactUsPhone">
                                            <div className="contactUsPhoneIcon">
                                                <Icon type="printer"/>
                                            </div>
                                            <div className="contactUsPhoneTitle">
                                                شماره فکس
                                            </div>
                                            <div className="contactUsPhonetext">{Info.FAX}</div>
                                        </div>
                                    </div>
                                </Col>


                                <Col xs={22} sm={20} md={14} lg={14} xl={14}>
                                    <div className="openTime">
                                        <div className="contactUsPhone">
                                            <div className="contactUsPhoneIcon">
                                                <Icon type="clock-circle"/>
                                            </div>
                                            <div className="contactUsPhoneTitle">
                                                ساعات پاسخگویی
                                            </div>

                                                <div className="openTimeMainItem">
                                                    <div className="openTimeItem">
                                                        <div className="openTimeItemTitle">
                                                            <span>شنبه تا چهارشنبه</span>
                                                        </div>
                                                        <div className="openTimeClocks">
                                                            <div className="openTimeClock">10:30
                                                                <span>
                                                                    AM
                                                                </span>
                                                            </div>
                                                            <div className="ela">الی</div>
                                                            <div className="openTimeClock">8:30
                                                                <span>
                                                                    PM
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="openTimeItem">
                                                        <div className="openTimeItemTitle">
                                                            <span>پنجشنبه</span>
                                                        </div>
                                                        <div className="openTimeClocks">
                                                            <div className="openTimeClock">10:30
                                                                <span>
                                                                    AM
                                                                </span>
                                                            </div>
                                                            <div className="ela">الی</div>
                                                            <div className="openTimeClock">8:30
                                                                <span>
                                                                    PM
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                        </div>
                                    </div>
                                    <div className="contactUsPhone">
                                        <div className="contactUsPhoneIcon">
                                            <Icon type="global"/>
                                        </div>
                                        <div className="contactUsPhoneTitle">
                                            شبکه‌های اجتماعی
                                        </div>
                                        <div className="openTimeMainItem">
                                            <div className="contactSocials">
                                                <div className="footerSocials">
                                                        <div className="footerSocial">
                                                            <a href="#">
                                                                <Icon type="facebook" />
                                                            </a>
                                                        </div>

                                                        <div className="footerSocial">
                                                            <a href="https://www.instagram.com/bayati.exchange/" target="_blank" rel="noopener noreferrer">
                                                                <Icon type="instagram" />
                                                            </a>
                                                        </div>

                                                        <div className="footerSocial">
                                                            <a href="#">
                                                                <Icon type="linkedin" />
                                                            </a>
                                                        </div>
                                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                            </Row>
                        </div>
                    </div>
                </div>
            </div>
            <div className="seprow">
                <div className={"seprator2"} dangerouslySetInnerHTML={seprator2()}>
                </div>
            </div>

            <div className={"contactUsSec2"}>
                <div className="container">
                   <Row className={"contactSec2Row"}>
                       <Col xs={22} sm={20} md={15} lg={15} xl={15}>
                           <Tilt className="Tilt" options={{ scale : 1.04 , max : 11 , perspective : 1300 }}>
                               <div className="Tilt-inner">
                                   <div className="contactFormCard">
                                       <div className="contactFormWrapper">
                                           <div>
                                            <Icon type="environment"/>
                                           </div>
                                           <h1>{Info.ADDRESS}</h1>
                                       </div>
                                   </div>
                               </div>
                           </Tilt>
                       </Col>
                   </Row>
                </div>
            </div>

            <div className="contactMapSec">
                <div className="container">
                    <div className="contactMapInner">
                        <div className="contactUsMap">
                          <Map center={[35.677084, 51.419753]} zoom={18} height={600}>
                            <Marker anchor={[35.677084, 51.419753]} payload={1} onClick={({ event, anchor, payload }) => {}} />
                            <Overlay anchor={[35.677084, 51.419753]} offset={[120, 79]}>
                              <img src='pigeon.jpg' width={240} height={158} alt='' />
                            </Overlay>
                          </Map>
                        </div>
                        <div className="contactUsMapGradientBorder"></div>
                    </div>
                </div>
            </div>
        </div>
        </MainLayout>
        )
    }
}
